import { render } from "./AuUpload.vue?vue&type=template&id=22fdc45a&scoped=true"
import script from "./AuUpload.vue?vue&type=script&lang=js"
export * from "./AuUpload.vue?vue&type=script&lang=js"

import "./AuUpload.vue?vue&type=style&index=0&id=22fdc45a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22fdc45a"]])

export default __exports__